import { render, staticRenderFns } from "./voice-room-main.vue?vue&type=template&id=541c6e30&scoped=true&"
import script from "./voice-room-main.vue?vue&type=script&lang=js&"
export * from "./voice-room-main.vue?vue&type=script&lang=js&"
import style0 from "./voice-room-main.vue?vue&type=style&index=0&id=541c6e30&lang=scss&scoped=true&"
import style1 from "./voice-room-main.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541c6e30",
  null
  
)

export default component.exports